import React from 'react';
import { useTranslation } from 'react-i18next';
import { TmShipmentItem } from '@/tscapi/model/order';

interface IOrderProduct {
    ShipmentItem: TmShipmentItem;
}

export const OrderProduct = ({ ShipmentItem }: IOrderProduct) => {
    const { t } = useTranslation();
    const item: TmShipmentItem = ShipmentItem;

    return (
        <>
            {item && (
                <div className="productlist">
                    <div className="productlist__row">
                        <div className="productlist__left">
                            <img
                                className="img-responsive"
                                src={'https://item.tscimg.ca/TSC/' + item.ItemImageURL + '?impolicy=XS'}
                            />
                        </div>
                        <div className="productlist__right">
                            <div className="productlist__description">
                                {item.Description}
                                {item.Style && (
                                    <span>
                                        <span className="pipe-char">|</span>
                                        {item.Style}
                                    </span>
                                )}
                                {item.Size && (
                                    <span>
                                        <span className="pipe-char">|</span>
                                        Size:{item.Size}
                                    </span>
                                )}
                            </div>

                            <div className="productlist__itemnumber">{item.ItemNoForDisplay}</div>
                        </div>
                    </div>

                    <div className="productlist__pricerow">
                        <div className="productlist__left--qty">
                            <span className="">{t('QTY')}: </span>
                            <span>{item.ItemQuantity}</span>
                        </div>
                        <div className="productlist__right">
                            <span className="productlist__right--price">{item.UnitPrice}</span>
                        </div>
                    </div>
                    {item.SellerType === 'Marketplace' && (
                        <div className="productlist_marketplace">
                            <img
                                src="/App_Assets/public/marketplace-icon.svg"
                                alt="marketplace-icon"
                                className="marketplace-icon"
                            />
                            <span className="marketplace-title">Marketplace Seller </span>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};
